import { Spiner } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import moment from "moment-timezone";
import { useEffect } from "react";
import { LuInbox } from "react-icons/lu";
moment.locale("id");

export const NonMonthlyBillPage = () => {
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state,
  );

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    queryFn: () => FinanceService.billsPaidOf({ nis }),
  });

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Kewajiban Non-Bulanan",
      image: false,
    });
    setAppBar({
      title: "Kewajiban Non-Bulanan",
      show: true,
      checkout: false,
      leading: "back",
    });
    setBottomNavigation("hidden");
  }, [setHeader, setBottomNavigation, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {isPending ? (
          <div className="tw-text-center card-body">
            <Spiner />
          </div>
        ) : (
          <>
            {data?.data?.filter((item) => item.jenis != "bulanan") != null &&
            data.data?.filter((item) => item.jenis != "bulanan").length > 0 &&
            data?.data.filter((item) => item.jenis != "bulanan") ? (
              <>
                {data?.data
                  .filter((item) => item.jenis != "bulanan")
                  .map((item, idx) => (
                    <div className="tw-mb-4 tw-py-4 card-body" key={idx}>
                      <div className="tw-mb-1 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                        <div className="tw-text-[10px] tw-font-medium tw-text-text-secondary">
                          kewajiban
                        </div>
                      </div>
                      <div className="tw-flex tw-justify-between tw-items-end tw-font-semibold tw-text-text-primary">
                        <div
                          className="tw-text-sm"
                          style={{
                            maxWidth: "50%",
                          }}
                        >
                          {item.tagihan}
                        </div>
                        <div className="tw-w-1/2 tw-text-end">
                          <div className="tw-text-base tw-text-text-primary">
                            {toRp(item.nominal)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center card-body">
                <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
                <div>Tidak ada kewajiban</div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
